import { createSelector } from 'reselect';

export const selectEPG = state => state.EPGWidget;

export const selectIsVisible = createSelector(
  selectEPG,
  epg => !!epg.isVisible,
);
